






export default
  name: 'FooterTopButton'

  methods: {
    go_top: () ->
      window.scrollTo(0, 0)
      @$emit('go_top')
  }
